import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ru from './locales/ru'
import uz from './locales/uz'
import store from '../store'

Vue.use(VueI18n)

const messages = {ru, uz}

const i18n = new VueI18n({
  locale: 'uz',
  messages
})

Vue.prototype.$locale = {
  change(lang) {
    i18n.locale = lang
    store.commit('Account/CHANGE_LANG', lang)
  },
  current() {
    return i18n.locale
  },
  datePicker() {
    return {
      month: messages[i18n.locale].month,
      days: messages[i18n.locale].days
    }
  }
}

export default i18n